import { PatientType, PracticeType } from "@context/antibioticContext";

export const COMMON_BODY_SYSTEMS = [
  "Genitourinary",
  "Respiratory",
  "Ear Nose and Throat",
  "Gastrointestinal",
  "Infection Unknown Source",
  "Eye and Orbit",
  "Dental",
  "Skin and Soft Tissue",
  "Sepsis/Infection Unknown Source"
];

export const BODY_SYSTEMS_BY_PATIENT_AND_PRACTICE: Record<
  PatientType,
  Record<PracticeType, string[]>
> = {
  Adult: {
    Primary: [
      "Central Nervous System",
      "Sexually Transmitted Infections",
      "Trauma",
      ...COMMON_BODY_SYSTEMS,
    ],
    Secondary: [
      "Cardiovascular",
      "Trauma",
      "Central Nervous System",
      "Maternal",
      "Bone and Joint",
      "Febrile Neutropenia",
      "Sexually Transmitted Infections",
      ...COMMON_BODY_SYSTEMS,
    ],
    "Surgical Prophylaxis": [
      "Cardiothoracic and cardiology procedures",
      "Dermatology procedures",
      "Dental",
      "Interventional radiology procedures",
      "General surgery",
      "Neurosurgery",
      "Obstetric or gynaecological surgery",
      "Orthopaedic surgery",
      "ORL surgery",
      "Plastic surgery",
      "Urological surgery",
      "Vascular surgery",
    ],
  },
  Pediatric: {
    Primary: [...COMMON_BODY_SYSTEMS],
    Secondary: [
      "Trauma",
      "Central Nervous System",
      "Bone and Joint",
      "Febrile Neutropenia",
      ...COMMON_BODY_SYSTEMS,
    ],
    "Surgical Prophylaxis": [
      "Cardiothoracic and cardiology procedures",
      "Dental",
      "General surgery",
      "Neurosurgery",
      "Orthopaedic surgery",
      "ORL surgery",
      "Urological surgery",
     ],
  },
};
